import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DashboardService } from  '../../../app/services/dashboard.service';
import { NavigationService } from '../../../app/services/navigation.service';
import { SessionService } from '../../../app/services/session.service';

@Component({
  selector: 'app-admin-layout',
  templateUrl: './admin-layout.component.html',
  styleUrls: ['./admin-layout.component.scss']
})
export class AdminLayoutComponent implements OnInit {

  clientLogo: any;
  newColor: any;
  moduleName: any;
  clientKey: any;
  moduleKey: any;

  constructor(
    private sessionService: SessionService,
    private router: ActivatedRoute,
    private dashboardService: DashboardService,
    private navigationService: NavigationService
  ) {
    this.router.params.subscribe((p: any) => {
      this.moduleName = p['module'] || '';

      this.router.queryParams.subscribe((params: any) => {
        let decryptedParams = this.navigationService.decryptData(params);
        this.clientKey = decryptedParams["cl_key"];
        this.moduleKey = decryptedParams["md_key"];

        this.dashboardService.moduleKey = this.moduleKey;
      })

    })
  }


  ngOnInit(): void {
    this.clientLogo = this.sessionService.getClintLogo();
    this.newColor = this.sessionService.getColorCodes();
  }
  previousPage() {
    this.navigationService.goBack();
  }

  openPage(page: any) {
    // let dashboardDetail = {
    //   dashboard_nm: page.dashboard_nm,
    //   work_nm: page.work_nm,
    //   dashboard_key: page.dashboard_key
    // }
    // sessionStorage.setItem("navbar_page_nm", JSON.stringify(dashboardDetail))
    let query:any = {
      tab_id: 0,
      cl_key: this.clientKey,
      md_key: this.moduleKey
    }
    this.navigationService.routerNavigate(`du-admin/${this.moduleName}/${page.route}`, query)
  }

  pages = [
    { 
      admin_page_nm: 'User Management', 
      access_flg: 'Y',
      route: 'user-management',
      img_url: 'https://dudemo-ui-scraii-s3.s3.amazonaws.com/assets/svgIcons/patientList.svg'
      // img_url: 'https://material.angular.dev/assets/img/examples/shiba1.jpg'
    },
    // { 
    //   admin_page_nm: 'Module Management', 
    //   access_flg: 'N',  
    //   route: 'module-management',
    //   img_url: ''
    //   // img_url: 'https://material.angular.dev/assets/img/examples/shiba2.jpg'
    // },
    // { 
    //   admin_page_nm: 'Dashboard Management', 
    //   access_flg: 'N', 
    //   route: 'dashboard-management',
    //   img_url: ''
    //   // img_url: 'https://material.angular.dev/assets/img/examples/shiba2.jpg'
    // },
  ];
}
